<h2 mat-dialog-title>{{title}}</h2>
@if (busy) {
  <div class="overlay">
    <div class="center">
      <mat-spinner>
      </mat-spinner>
    </div>
  </div>
}
<mat-dialog-content>
  <div class="w-100 py-5">
    <div>Current High Bid: {{property.auction?.highestBidAmount | currency:'USD':'symbol':'1.2-2'}}</div>
    <div>Current Reserve: {{property.auction?.reservePrice | currency:'USD':'symbol':'1.2-2'}}</div>
    <div>Bid Increment: {{property.auction?.increment | currency:'USD':'symbol':'1.2-2'}}</div>
    <form [formGroup]="hotEditForm" class="flex-col mt-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>New Reserve</mat-label>
        <input matInput autocomplete="off" formControlName="reservePrice" type="number" [min]="minimumReservePrice" required>
        @if (hotEditForm.get('reservePrice')!.errors?.['required']) {
          <mat-error>Value is required</mat-error>
        }
        <mat-hint>Value cannot be less than current high bid plus increment.</mat-hint>
      </mat-form-field>
    </form>
  </div>
</mat-dialog-content>

<mat-dialog-actions >
  <div class="flex-row spce-between items-center w-100 mt-3 p-2">
    <button [disabled]="!canSubmit" mat-flat-button class="w-50" color="primary" (click)="onConfirmClick()" tabindex="1" >{{confirmButtonText}}</button>
    <button [disabled]="!canCancel" mat-flat-button class="w-50" color="primary" (click)="onCancelClick()" >{{cancelButtonText}}</button>
  </div>
</mat-dialog-actions>

